<template>
  <div class="email-verify-field">
    <div class="email-field__title dea-heading--medium-xs">
      <div class="email-field__title-label">
        {{ title.toUpperCase() }}
      </div>
    </div>
    <div v-for="(mail, index) in mailsList" :key="index" class="email-field__item">
      <div class="email-field__item-content">
        <div class="email-field__content-label dea-heading--medium-s">
          {{ mail }}
        </div>
        <Links
          class="email-field__item-content-link dea-links--large"
          :class="`dea-links--${linkColor}`"
          @click="$emit('email-delete', mail)"
        >
          Cancella richiesta di verifica
        </Links>
      </div>
      <div class="email-field__item-remove-email">
        <Links
          class="email-field__item-content-link dea-links--large"
          :class="`dea-links--${linkColor}`"
          @click="$emit('email-verify', mail, 'save')"
        >
          Invia di nuovo mail di verifica
        </Links>
      </div>
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";

export default {
  name: "EmailVerifyField",
  components: { Links },
  props: {
    isChildren: {
      type: Boolean,
      default: false,
    },
    linkColor: {
      type: String,
      default: "",
    },
    mailsList: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      required: "",
    },
    showRemoveEmail: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      if (this.field) {
        return this.field;
      }
      return this.placeholder;
    },
    link() {
      if (this.field) {
        return "Modifica";
      }
      return "Aggiungi";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.email-field {
  @include media("<=s") {
    margin-top: $space-x-large;
  }
  margin-bottom: $space-large;
  margin-top: $space-xx-large;

  &__title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: $space-x-small;
  }

  &__item {
    margin: $space-x-small 0;

    &-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      &-link {
        cursor: pointer;
      }
    }

    &-remove-email {
      display: flex;
      flex-direction: row-reverse;
      margin-top: $space-x-small;
    }

    &-description {
      margin-bottom: $space-small;
      margin-top: $space-x-small;
    }
  }
}
</style>
